<template>
  <q-route-tab
    to="/flagged"
    name="flagged"
    :label="label"
    exact
    v-bind="$attrs"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters } from '@/type';
import { matches, status } from '@/social/post/post';
import postRepository from '@/social/post/post-repository';
import eventBus from '@/messaging/event-bus';
import {
  PostTrashed,
  PostRestored,
} from '@/messaging/events';

interface Data {
  total: number,
  filters: PostFilters
}

export default defineComponent({
  data(): Data {
    return {
      total: -1,
      filters: {
        statuses: [status.UNREVIEWED, status.SAVED, status.ESCALATED, status.RESOLVED],
        socialSiteIds: [],
        isTrashed: false,
        isFlagged: true,
        since: null,
        until: null,
      },
    };
  },
  computed: {
    label(): string {
      if (this.total === -1) return 'Flagged';
      return `Flagged (${this.total})`;
    },
  },
  methods: {
    load() {
      postRepository.count(this.filters).then((total) => {
        this.total = total;
      });
    },
    decrement() {
      this.total -= 1;
    },
    increment() {
      this.total += 1;
    },
    onPostTrashed(e: PostTrashed) {
      const post = Object.assign({}, e.post, { isTrashed: false });
      if (matches(post, this.filters)) this.decrement();
    },
    onPostRestored(e: PostRestored) {
      if (matches(e.post, this.filters)) this.increment();
    },
  },
  created() {
    eventBus.$on(PostTrashed.eventName, this.onPostTrashed);
    eventBus.$on(PostRestored.eventName, this.onPostRestored);
    this.load();
  },
  beforeUnmount() {
    eventBus.$off(PostTrashed.eventName, this.onPostTrashed);
    eventBus.$off(PostRestored.eventName, this.onPostRestored);
  },
});
</script>
